const appSettingsNames = require('./lib/models/app/settingsNames')
/**
 * @module RoAppBackend
 * @type {{APP_SETTINGS: SettingsNames}}
 */
module.exports = {
    APP_SETTINGS: appSettingsNames
}


//////////////////
// WEBPACK FOOTER
// .-backend/index.js
// module id = nNBo
// module chunks = 5